import * as React from 'react';
import { Field, FormSection, InjectedFormProps, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { FormsLocale } from './forms.locale';
import { required, email, phone, asNumber } from '../../../containers/Validator/validator';
import { RootState } from '../../../RootState';
import FormComponent from '../../Form/Form';
import Input from '../../Input/Input';
import TextArea from '../../Input/TextArea';
import Button from '../../Button/Button';
import Checkbox from '../../Input/Checkbox/Checkbox';
import ThankYou from '../../Form/ThankYou';

export interface FormData {
  contact: {
    company: string;
    asNumber: string;
    noAs: boolean;
    fullName: string;
    jobTitle: string;
    emailAddress: string;
    phoneNumber: string;
  };
  message: string;
}

interface StateProps {
  isAsnDisabled: boolean;
}

interface OwnProps {
  locale: FormsLocale;
}

interface SalesFormProps
  extends InjectedFormProps<FormData, OwnProps & StateProps>,
    StateProps,
    OwnProps {}

const SalesForm: React.SFC<SalesFormProps> = ({
  isAsnDisabled,
  locale,
  submitting,
  handleSubmit,
  error,
  submitSucceeded,
}) => (
  <FormComponent title={locale.salesTitle} loading={submitting} error={error}>
    {submitSucceeded ? (
      <ThankYou thanksText={locale.salesThankYou} />
    ) : (
      <form onSubmit={handleSubmit}>
        <FormSection name="contact">
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="company"
                component={Input}
                props={{ label: locale.company, type: 'text' }}
                validate={required}
              />
            </div>
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="asNumber"
                component={Input}
                props={{ label: locale.asNumber, type: 'text' }}
                disabled={isAsnDisabled}
                validate={isAsnDisabled ? undefined : [required, asNumber]}
              />
              <div className="mt-2">
                <Field name="noAs" id="noAs" component={Checkbox} props={{ label: locale.noAs }} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="fullName"
                component={Input}
                props={{ label: locale.name, type: 'text' }}
                validate={required}
              />
            </div>
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="jobTitle"
                component={Input}
                props={{ label: locale.job, type: 'text' }}
                validate={required}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="emailAddress"
                component={Input}
                props={{ label: locale.email, type: 'email' }}
                validate={[required, email]}
              />
            </div>
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="phoneNumber"
                component={Input}
                props={{ label: locale.phone, type: 'tel' }}
                validate={[required, phone]}
              />
            </div>
          </div>
        </FormSection>

        <div className="row">
          <div className="col-12 mb-3">
            <Field
              name="message"
              component={TextArea}
              props={{
                label: locale.message,
                placeholder: '',
              }}
              validate={required}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <Button type="submit">{locale.confirm}</Button>
        </div>
      </form>
    )}
  </FormComponent>
);

const ConnectedSalesForm = reduxForm<FormData, OwnProps & StateProps>({
  form: 'contactSales',
  destroyOnUnmount: false,
  initialValues: {
    contact: {
      company: '',
      asNumber: '',
      noAs: false,
      fullName: '',
      jobTitle: '',
      emailAddress: '',
      phoneNumber: '',
    },
    message: '',
  },
})(SalesForm);

const mapStateToProps = (state: RootState) => {
  const formValues = getFormValues('contactSales')(state) as FormData;

  return {
    isAsnDisabled: formValues ? formValues.contact.noAs : false,
  };
};

export default connect<StateProps, {}, OwnProps, RootState>(mapStateToProps)(ConnectedSalesForm);



// WEBPACK FOOTER //
// /www/client/src/components/ContactPage/Forms/SalesForm.tsx